
define('text!templates/modal.ejs',[],function () { return '<div class="modal-backdrop">\n\n    <div class="modal <%= animateClass %>">\n        <div class="modal-header">\n        </div>\n        <div class="modal-body">\n            <%- body %>\n        </div>\n        <% if (showFooter) { %>\n        <div class="modal-footer">\n        </div>\n        <% } %>\n    </div>\n\n</div>';});

